// Ce fichier est généré automatiquement par le devtool
// Ne pas modifier manuellement

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const IconsMoreSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'icons-more',
    metadata: {
      frames: {
        'soul-shard': {
          frame: {
            x: 176,
            y: 240,
            w: 16,
            h: 16,
          },
          sourceSize: {
            w: 16,
            h: 16,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 16,
            h: 16,
          },
        },
        'spirit-heart': {
          frame: {
            x: 192,
            y: 240,
            w: 16,
            h: 16,
          },
          sourceSize: {
            w: 16,
            h: 16,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 16,
            h: 16,
          },
        },
        'far-talisman': {
          frame: {
            x: 32,
            y: 368,
            w: 16,
            h: 16,
          },
          sourceSize: {
            w: 16,
            h: 16,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 16,
            h: 16,
          },
        },
        'thunder-in-a-box': {
          frame: {
            x: 176,
            y: 400,
            w: 16,
            h: 16,
          },
          sourceSize: {
            w: 16,
            h: 16,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 16,
            h: 16,
          },
        },
        'run-modifier': {
          frame: {
            x: 464,
            y: 416,
            w: 16,
            h: 16,
          },
          sourceSize: {
            w: 16,
            h: 16,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 16,
            h: 16,
          },
        },
      },
      meta: {
        image: '/sprites/icons/items_sheet.png',
        size: {
          w: 576,
          h: 560,
        },
        scale: '1',
      },
    },
  },
];
